import { render, staticRenderFns } from "./CertificationsMovements.vue?vue&type=template&id=65ad4e84&scoped=true&"
import script from "./CertificationsMovements.vue?vue&type=script&lang=js&"
export * from "./CertificationsMovements.vue?vue&type=script&lang=js&"
import style0 from "./CertificationsMovements.vue?vue&type=style&index=0&id=65ad4e84&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ad4e84",
  null
  
)

export default component.exports